import React from 'react';

import { useQuery } from '@tanstack/react-query';
import { getChangeAppointmentReasons } from '@uplift/api';
import { ChangeSessionReasonTypes, UserRole } from '@uplift/types';

export const useChangeSessionReasonsQuery = (
  userRole: UserRole,
  type: ChangeSessionReasonTypes
) => {
  const roles = React.useMemo(() => {
    // For Admin we want both patient and provider reasons to display in this query
    if (userRole === UserRole.superadmin) {
      return [ UserRole.patient, UserRole.provider ];
    }

    return [ userRole ];
  }, [ userRole ]);

  const { data, isLoading } = useQuery({
    queryKey: [ 'change-session-reasons', type, roles ],
    queryFn: () => getChangeAppointmentReasons(type, roles),
    select: (data) => data?.data,
  });

  return {
    fetching: isLoading,
    reasons: data ?? [],
  };
};
